import type { Locale } from '../context/LocaleContext';

const texts: Record<Locale, Record<string, string>> = {
  zh: {
    siteTitle: 'For Pro Journey 你好，旅行者！',
    siteSubtitle: '欧洲旅行导航，签证门票官网直达',
    visa: '签证',
    visaFree: '免签',
    visaOnArrival: '落地签',
    visaRequired: '需要签证',
    back: '返回列表',
    applyVisa: '在线办理签证',
    noVisa: '无需办理签证',
    popularity: '热度排名',
    continent: '大洲',
    travelInfo: '旅行信息',
    attractions: '景点',
    cityPasses: '城市交通',
    bestMonths: '最佳月份',
    price: '价格',
    bookInAdvance: '需预订',
    daysInAdvance: '提前{n}天',
    officialTickets: '官方购票',
    viewMore: '查看更多景点',
    noAttractions: '暂无景点',
    moreAttractions: '还有 {n} 个景点',
    contact: '联系我们',
    europe: '欧洲',
    searchPlaceholder: '输入国家中文名或英文名...',
    showingCountries: '显示 {n} 个国家（按旅行热度排序）',
    noCountries: '暂无国家数据',
    retry: '重试',
    bestTime: '最佳时间',
    climateInfo: '气候信息',
    noTravelInfo: '暂无旅行信息',
    noAttractionsInfo: '暂无景点信息',
    countries: '国家信息',
    searchResult: '搜索"{q}"的结果',
    footerTagline: 'ForProJourney - 为您的全球旅行提供官方信息导航',
    footerOfficialOnly: '所有链接均指向官方网站，请谨慎对待第三方网站',
    footerReportIssue: '如果遇到链接指向错误或者链接失效问题，请发邮件到',
    selectContinent: '选择大洲',
    searchOrSelectCountry: '搜索或选择国家',
    noMatchedCountries: '未找到匹配的国家',
    adjustFiltersHint: '请尝试调整筛选条件或稍后再试',
    retryLoad: '重试',
    loadFailed: '加载失败',
    countryNotFound: '国家不存在',
    countryNotFoundById: '未找到 ID 为 {id} 的国家',
    schengen: '申根区',
    jurisdiction: '领区',
    applyOnArrival: '入境时办理',
    visaInfo: '签证信息',
    contactEmbassy: '请联系使领馆',
    visaFreeCountry: '免签国家',
    peakSeason: '旺季',
    notices: '注意事项',
    currency: '货币',
    noCurrencyInfo: '暂无货币信息',
    language: '语言',
    noLanguageInfo: '暂无语言信息',
    timezone: '时区',
    noTimezoneInfo: '暂无时区信息',
    popularAttractions: '热门景点',
    filterByCity: '按城市筛选',
    allCities: '全部城市',
    showingAttractions: '显示 {n} 个景点',
    showAll: '显示全部',
    regionalPasses: '区域通票',
    validity: '有效期',
    buyPass: '购买通票',
    cities: '个城市',
    transportation: '交通方式',
    whereToBuy: '在哪购买',
    buySuggestion: '购买建议',
    localFood: '本地美食',
    localSpecialties: '本地特色食物',
    mealPrice: '每餐均价',
    tippingCulture: '小费文化',
    importantNotice: '重要提醒',
    findAuthenticFood: '如何找到地道美食',
  },
  en: {
    siteTitle: 'For Pro Journey — Hello, Traveler!',
    siteSubtitle: 'Europe travel guide · Tickets to official sites',
    visa: 'Visa',
    visaFree: 'Visa-free',
    visaOnArrival: 'Visa on arrival',
    visaRequired: 'Visa required',
    back: 'Back to list',
    applyVisa: 'Apply for visa online',
    noVisa: 'No visa required',
    popularity: 'Popularity',
    continent: 'Continent',
    travelInfo: 'Travel info',
    attractions: 'Attractions',
    cityPasses: 'City passes',
    bestMonths: 'Best months',
    price: 'Price',
    bookInAdvance: 'Booking required',
    daysInAdvance: '{n} days in advance',
    officialTickets: 'Official tickets',
    viewMore: 'View more attractions',
    noAttractions: 'No attractions',
    moreAttractions: '+{n} more',
    contact: 'Contact us',
    europe: 'Europe',
    searchPlaceholder: 'Search by country name (EN/中文)...',
    showingCountries: 'Showing {n} countries (by popularity)',
    noCountries: 'No countries',
    retry: 'Retry',
    bestTime: 'Best time',
    climateInfo: 'Climate',
    noTravelInfo: 'No travel info',
    noAttractionsInfo: 'No attractions',
    countries: 'Countries',
    searchResult: 'Search result for "{q}"',
    footerTagline: 'ForProJourney - Official information guide for global travel',
    footerOfficialOnly: 'All links point to official websites. Please be careful with third-party sites.',
    footerReportIssue: 'If you find broken or incorrect links, please email',
    selectContinent: 'Select continent',
    searchOrSelectCountry: 'Search or select countries',
    noMatchedCountries: 'No matching countries found',
    adjustFiltersHint: 'Try adjusting filters or retry later.',
    retryLoad: 'Retry',
    loadFailed: 'Load failed',
    countryNotFound: 'Country not found',
    countryNotFoundById: 'No country found with ID {id}',
    schengen: 'Schengen',
    jurisdiction: 'Jurisdiction',
    applyOnArrival: 'Apply on arrival',
    visaInfo: 'Visa info',
    contactEmbassy: 'Please contact the embassy/consulate',
    visaFreeCountry: 'Visa-free country',
    peakSeason: 'Peak season',
    notices: 'Notices',
    currency: 'Currency',
    noCurrencyInfo: 'No currency info',
    language: 'Language',
    noLanguageInfo: 'No language info',
    timezone: 'Timezone',
    noTimezoneInfo: 'No timezone info',
    popularAttractions: 'Popular attractions',
    filterByCity: 'Filter by city',
    allCities: 'All cities',
    showingAttractions: 'Showing {n} attractions',
    showAll: 'Show all',
    regionalPasses: 'Regional passes',
    validity: 'Validity',
    buyPass: 'Buy pass',
    cities: 'cities',
    transportation: 'Transportation',
    whereToBuy: 'Where to buy',
    buySuggestion: 'Purchase tips',
    localFood: 'Local food',
    localSpecialties: 'Local specialties',
    mealPrice: 'Average meal cost',
    tippingCulture: 'Tipping culture',
    importantNotice: 'Important notice',
    findAuthenticFood: 'How to find authentic local food',
  },
};

export function t(locale: Locale, key: string, params?: Record<string, string | number>): string {
  let s = texts[locale]?.[key] ?? texts.zh[key] ?? key;
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
  }
  return s;
}
